// extracted by mini-css-extract-plugin
export var grid = "_2x-0";
export var span1 = "_2x-2";
export var span10 = "_2x-b";
export var span10L = "_2x-z";
export var span10M = "_2x-n";
export var span10Xl = "_2x-1b";
export var span11 = "_2x-c";
export var span11L = "_2x-10";
export var span11M = "_2x-o";
export var span11Xl = "_2x-1c";
export var span12 = "_2x-d";
export var span12L = "_2x-11";
export var span12M = "_2x-p";
export var span12Xl = "_2x-1d";
export var span1L = "_2x-q";
export var span1M = "_2x-e";
export var span1Xl = "_2x-12";
export var span2 = "_2x-3";
export var span2L = "_2x-r";
export var span2M = "_2x-f";
export var span2Xl = "_2x-13";
export var span3 = "_2x-4";
export var span3L = "_2x-s";
export var span3M = "_2x-g";
export var span3Xl = "_2x-14";
export var span4 = "_2x-5";
export var span4L = "_2x-t";
export var span4M = "_2x-h";
export var span4Xl = "_2x-15";
export var span5 = "_2x-6";
export var span5L = "_2x-u";
export var span5M = "_2x-i";
export var span5Xl = "_2x-16";
export var span6 = "_2x-7";
export var span6L = "_2x-v";
export var span6M = "_2x-j";
export var span6Xl = "_2x-17";
export var span7 = "_2x-8";
export var span7L = "_2x-w";
export var span7M = "_2x-k";
export var span7Xl = "_2x-18";
export var span8 = "_2x-9";
export var span8L = "_2x-x";
export var span8M = "_2x-l";
export var span8Xl = "_2x-19";
export var span9 = "_2x-a";
export var span9L = "_2x-y";
export var span9M = "_2x-m";
export var span9Xl = "_2x-1a";
export var stretch = "_2x-1";